// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 796 ? "public-legal" : chunkId) + "." + {"281":"15236dd8","796":"a73aa244"}[chunkId] + ".chunk.js";
};